"use strict";

var cov_1swjmakj83 = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Toolbar.js";
  var hash = "93bcccba9029a22d14ea6b854535183e8072b8bf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Toolbar.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "1": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      "2": {
        start: {
          line: 34,
          column: 0
        },
        end: {
          line: 43,
          column: 2
        }
      },
      "3": {
        start: {
          line: 45,
          column: 18
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "4": {
        start: {
          line: 45,
          column: 39
        },
        end: {
          line: 52,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "Toolbar",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 16
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 45,
            column: 29
          },
          end: {
            line: 45,
            column: 30
          }
        },
        loc: {
          start: {
            line: 45,
            column: 39
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 45
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "93bcccba9029a22d14ea6b854535183e8072b8bf"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _ = require("..");

function Toolbar(_ref) {
  var title = _ref.title,
      actions = _ref.actions,
      buttons = _ref.buttons;
  cov_1swjmakj83.f[0]++;
  var classes = (cov_1swjmakj83.s[0]++, useStyles());
  cov_1swjmakj83.s[1]++;
  return _react.default.createElement(_core.Grid, {
    container: true,
    direction: "row",
    justify: "space-between",
    alignItems: "center",
    className: classes.root
  }, _react.default.createElement(_core.Grid, {
    item: true
  }, _react.default.createElement(_core.Typography, {
    variant: "h6",
    className: classes.title
  }, title)), _react.default.createElement(_core.Grid, {
    item: true
  }, _react.default.createElement(_.Actions, {
    actions: actions,
    buttons: buttons
  })));
}

;
cov_1swjmakj83.s[2]++;
Toolbar.propTypes = {
  title: _propTypes.default.string.isRequired,
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.element.isRequired,
    tooltip: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func
  }).isRequired)
};
var useStyles = (cov_1swjmakj83.s[3]++, (0, _styles.makeStyles)(function (theme) {
  cov_1swjmakj83.f[1]++;
  cov_1swjmakj83.s[4]++;
  return {
    root: {
      padding: "0",
      background: '#fff'
    },
    title: {}
  };
}));
var _default = Toolbar;
exports.default = _default;